import {ajaxGet} from "../shared/ajax";

const signUp = () => {
    const form = document.querySelector('#sign_up_form')
    if(!form) return

    //toggle coupon input
    const couponCheckbox = form.querySelector('#form_i_have_coupon')
    const couponElement = form.querySelector('#form_coupon')
    if(couponCheckbox && couponElement){
        couponCheckbox.addEventListener('change', (event) => {
            const isChecked = event.target.checked;
            if(isChecked){
                couponElement.parentElement.style.display = 'block'
            }
            else{
                couponElement.value = ''
                resetValidation(couponElement)
                redrawMembershipPrices(couponElement)
                couponElement.parentElement.style.display = 'none'
            }
        });
    }


    //live validation
    const elementsToValidate = ['#form_email', '#form_username', '#form_coupon']

    let prevCouponState;

    const handleChange = async (selector, value) => {

        const element = form.querySelector(selector)
        if(!element) return

        resetValidation(element) //resets current state -> messages, classes

        //validate
        const input = selector.replace(/^#form_/, '');
        const response = await validateByAjax(input, value)
        if(response.state === 'ok'){
            element.classList.add('is-valid')
        }
        else{
            element.classList.add('is-invalid')
            element.parentElement.insertAdjacentHTML(
                'beforeend',
                '<div class="invalid-feedback d-block">'+response.message+'</div>'
            )
        }

        //load coupon prices
        if(input === 'coupon'){
            //prevent calling ajax when still typing, or when from invalid state to another invalid state.
            if(response.state !== prevCouponState){
                redrawMembershipPrices(element)
            }
            prevCouponState = response.state;
        }
    };


    const redrawMembershipPrices = (couponElement) => {
        let redrawPricesLink = couponElement.getAttribute('data-link').replace('-1', couponElement.value);

        const membershipInputs = form.querySelectorAll('input[name="form[membership]"]');
        membershipInputs.forEach((input) => {
            if (input.checked) {
                redrawPricesLink = redrawPricesLink + '?membership='+(input.getAttribute('data-position'))
            }
        });

        ajaxGet({url: redrawPricesLink})
    }



    //reset validation state -> removes classes, messages from element
    const resetValidation = (element) => {
        //reset current state
        element.classList.remove('is-invalid')
        element.classList.remove('is-valid')
        const htmlMsg = element.parentElement.querySelector('.invalid-feedback')
        if(htmlMsg){
            htmlMsg.remove()
        }
    }


    //ajax post to validate by backend, we do not use our ajaxPost, because it re-initializes itself after success
    const validateByAjax = async (input, value) => {
        const url = form.dataset.link;

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    input: input,
                    value: value
                })
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const json = await response.json();
            return json;
        } catch (error) {
            console.error('Fetch error:', error);
            return {};
        }
    };




    //advanced listener on change
    let lastValues = []
    let debounceTimers = []
    elementsToValidate.forEach(function (selector){
        const element = form.querySelector(selector)
        if(element){

            element.addEventListener('change', (event) => {
                const value = event.target.value
                if (typeof lastValues[selector] != undefined && value === lastValues[selector]) {
                    return; //nothing changed
                }
                lastValues[selector] = value;
                handleChange(selector, value);
            });

            element.addEventListener('keyup', (event) => {
                const value = event.target.value;
                lastValues[selector] = value;
                if(typeof debounceTimers[selector] != undefined){
                    clearTimeout(debounceTimers[selector]);
                }
                debounceTimers[selector] = setTimeout(() => {
                    handleChange(selector, value);
                }, 600);
            });
        }
    })

}

export default signUp;